var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.526,
    height: 27.908,
    viewBox: "0 0 36.526 27.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(-38.496 -711.634)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 28.219,
    height: 17.258,
    rx: 0.774,
    transform: "translate(42.618 720.784)",
    fill: "#8b96ab",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M73.522,713.134h-.063a2.622,2.622,0,0,0-2.622,2.622V735.42a2.622,2.622,0,0,1-2.622,2.622H45.24a2.622,2.622,0,0,1-2.622-2.622V715.756A2.622,2.622,0,0,0,40,713.134h0",
    fill: "none",
    stroke: "#8b96ab",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/WaterIcon.67436048b0b964125ce70d917a453b24.svg";
export { ForwardRef as ReactComponent };